import React from 'react';
import styles from './App.module.css';
import EventsList from '../components/EventsList/EventsList';
import EventDetail from '../components/EventDetail/EventDetail';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Events from './list_of_events.js';
import Header from '../components/Header/Header'
import OTownMap from '../components/Map/SVG_Component/OTownMap.jsx'
import MapPage from '../components/Map/MapPage/MapPage.jsx'
import Home from '../components/Home/Home.jsx';
import ProtectedRoute from '../components/ProtectedComponentSetup/ProtectedPassCodeRouteWrapper/ProtectedPassCodeRouteWrapper.jsx';



function App() {

  console.log(process.env.REACT_APP_API_URL);
  
  return (
    <BrowserRouter>
      <div className={styles.App}>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<EventsList events={Events} />} />
          <Route path="/ogMap" 
            element= {
            <ProtectedRoute>
              <MapPage />
            </ProtectedRoute>
            }
          />
        </Routes>
        <footer className={styles.footer}>
          <span>Contact: ogdenresistance@gmail.com</span>
          <span>*We Fight for the Constitution.</span>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
